module.exports = __webpack_public_path__ + "static/img/7.d3a87e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/7.png
// module id = 6cSw
// module chunks = 0